'use client';
/** @jsxImportSource @emotion/react */

import type { ImageListItemProps } from '@mui/material/ImageListItem';

import MuiImageListItem from '@mui/material/ImageListItem';

export type { ImageListItemProps };
export const ImageListItem = MuiImageListItem;
